module.exports = __webpack_public_path__ + "img/9ab8b63.png";